
import { VatGroup } from "@/utils/peppol/vat-group";
import { roundDecimalsAdvanced } from "@/utils/numbers";
import Vue from "vue";

export default Vue.extend({
	props: {
		vatGroup: {
			type: Object as ()=>VatGroup,
			required: true
		}
	},
	methods: {
		formatNumber(value: number): string {
			return roundDecimalsAdvanced(value, {
				decimals: 2,
				decimalSeperator: ",",
				thousandsSeperator: ".",
				thousandSeperatorInterval: 3
			});
		}
	}
});
